// รูปแบบตัวเลขของระบบ insight — ภาษาธรรมดา อ่านง่าย (ไม่มีศัพท์สถิติ)

export function money(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '-';
  const v = Number(n);
  const abs = Math.abs(v);
  if (abs >= 1e6) return `${(v / 1e6).toLocaleString('th-TH', { maximumFractionDigits: 2 })} ลบ.`;
  if (abs >= 1e3) return `${Math.round(v / 1e3).toLocaleString('th-TH')}k`;
  return Math.round(v).toLocaleString('th-TH');
}

export function percent(part, whole) {
  if (!whole) return null;
  return Math.round((part / whole) * 100);
}

export function timeOf(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Bangkok' });
}
